import YourBookmarks from "./YourBookmarks";

export default YourBookmarks;